<template>
    <section v-if="!isletterActive">
        <div v-if="lobSettingStore.lobSetting" class="row">
            <div class="col-12 form-group">
                <div class="demo-inline-spacing">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="mode_off" name="mode" @change="modeChange()" v-model="lobSettingStore.lobSetting.mode" class="custom-control-input" value="0" />
                        <label class="custom-control-label" for="mode_off">Test</label>
                    </div>
                    <div class="custom-control custom-radio">
                        <input type="radio" id="mode_on" name="mode" @change="modeChange()" v-model="lobSettingStore.lobSetting.mode" class="custom-control-input" value="1" />
                        <label class="custom-control-label" for="mode_on">Live</label>
                    </div>
                </div>
            </div>
        </div>
        <vue-good-table
            mode="remote"
            v-on:page-change="onPageChange"
            v-on:per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :isLoading.sync="isLoading"
            :pagination-options="{
                enabled: true,
                perPageDropdown: [10, 20, 30, 40, 50, 100],
                dropdownAllowAll: false,
            }"
            :rows="rows"
            :columns="columns"
            :sort-options="{
                enabled: false
            }"
        >
            <template #table-row="props">
                <span v-if="props.column.field === 'action'">
                    <span v-if="this.lobSettingStore.lobSetting.app_debug==true">
                        <p v-if="props.row.tracking_events.length > 0">{{ localizationStore.translate("lob.events.debug") }}</p>
                    </span>          
                    <div class="d-flex align-items-center col-actions">
                        <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="View Lob Letter">
                            <vue-feather type="eye" @click="viewLetter(props.row.id)"></vue-feather>
                        </a>
                        <a class="mr-1 text-danger" data-toggle="tooltip" data-placement="top" title="This letter's send date has passed, and it is no longer cancelable.">
                            <vue-feather type="x-octagon" @click="deleteLetter(props.row.id)"></vue-feather>
                        </a>
                    </div>
                </span>
                <img class="img-thumbnail" v-if="props.column.field == 'thumbnail'" :src="props.row.thumbnails[0].small" />
            </template>
        </vue-good-table>
    </section>
    <section v-else>
        <button @click="goBack()" class="btn mt-2 mb-2 btn-success">
          Back
        </button>
        <div class="row match-height">
          <!-- main title -->
          <div class="col-12 col-md-12 col-lg-12">
            <div class="card">
              <div class="card-body text-center">
                <div class="text-center">
                  <h1 class="mb-2 mt-2">Letter to {{ lobLetter.to.name }} from {{ lobLetter.from.name }}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- message image head -->
        <div class="col-lg-12 mt-5 mb-5 col-md-12 col-12">
            <div class="card card-profile bg-light">
              <div class="card-body">
                <div class="profile-image-wrapper">
                  <div class="profile-image">
                    <div class="avatar">
                      <img :src="baseUrl + '/images/logo/logo1.jpg'" alt="Profile Picture" />
                    </div>
                  </div>
                </div>
                
                <div class="row match-height">
                  <!-- main title -->
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="card-header border-light">
                      <h1>{{ localizationStore.translate("lob.letter.details") }}</h1>
                    </div>
                    <div class="text-left card-body border-light pl-2">
                      <p class="mb-0">Color: {{ lobLetter.color }}</p>
                      <p class="mb-0">Return Envelope: {{ lobLetter.return_envelope }}</p>
                      <p class="mb-0">Extra Service: {{ extraServices[lobLetter.extra_service] }}</p>
                      <p class="mb-0">Mail Type: {{ mailTypes[lobLetter.mail_type] }}</p>
                      <p class="mb-0">Date Created:  {{ moment(lobLetter.date_created).format('llll') }}</p>
                      <p class="mb-0">Expected Delivery Date: {{ moment(lobLetter.expected_delivery_date).format('ll') }}</p>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="card-header border-light mx-auto">
                      <h1>{{ localizationStore.translate("lob.letter.tracking.status") }}</h1>
                    </div>
                    <ul class="timeline mx-auto" v-if="lobLetter.tracking_events.length > 0">
                        <li v-for="tracking_event in lobLetter.tracking_events" class="timeline-item">
                          <span class="timeline-point timeline-point-indicator"></span>
                          <div class="timeline-event">
                            <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                              <h6>{{tracking_event.name}}</h6>
                            </div>
                          </div>
                        </li>
                    </ul>
                    <h6 v-else class="mt-1 mb-1 float-right">{{ localizationStore.translate("lob.tracking.status") }}</h6>

                  </div>
                </div>
                
                <h6 v-if="lobLetter.tracking_number == null">{{ localizationStore.translate("lob.letter.tracking.not.available.message") }}</h6>
                <h6 v-else class="mt-1 mb-1">Tracking Number : {{ lobLetter.tracking_number }}</h6>
                <div class="text-success mt-1 mb-1">
                  {{ extraServices[lobLetter.extra_service] }}
                </div>
                <a class="btn btn-success" :href="this.lobSettingStore.lobSetting.lob_more_detals+this.lobLetter.id">More Detail</a> 
              </div>
            </div>
          </div>
        <div id="card-navigation" class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-header">
                  <h1 class="text-center">Recipient</h1>
                </div>
                <div class="card-body text-left">
                  <p class="mb-0">{{ lobLetter.to.name }}</p>
                  <p class="mb-0">{{ lobLetter.to.address_line1 }}</p>
                  <p class="mb-0">{{ lobLetter.to.address_city }}, {{ lobLetter.to.address_state }} {{ lobLetter.to.address_zip }}</p>
                  <p class="mb-0">{{ lobLetter.to.address_country }}</p>
                  <span class="float-right text-success">{{ lobLetter.to.id }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card text-center mb-3">
                <div class="card-header">
                  <h1 class="text-center">Sender</h1>
                 </div>
                <div class="card-body text-left">
                  <p class="mb-0">{{ lobLetter.from.name }}</p>
                  <p class="mb-0">{{ lobLetter.from.address_line1 }}</p>
                  <p class="mb-0">{{ lobLetter.from.address_city }}, {{ lobLetter.from.address_state }} {{ lobLetter.from.address_zip }}</p>
                  <p class="mb-0">{{ lobLetter.from.address_country }}</p>
                  <span class="float-right text-success">{{ lobLetter.from.id }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- image and button -->
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="card text-center">
              <div class="card-header d-flex justify-content-center">
                <img :src="lobLetter.thumbnails[0].large" alt="Lob Letter Thumbnail" />
              </div>
              <div class="card-body mt-2 mb-2">
                <a :href="lobLetter.url" target="_blank" class="btn text-success border-success">View Letter</a>
              </div>
            </div>
          </div>
        </div>
        <!-- sender receipt -->
    </section>
</template>
<script>
  import { ref, reactive, computed } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import moment from 'moment';
  import { useLobSettingStore } from '../stores/LobSettingStore.js'
  import { useLocalizationStore } from '../stores/LocalizationStore.js';
  export default {
      components: {
          VueGoodTable,
      },
      setup(props) {
        return {
          lobSettingStore: useLobSettingStore(),
          lobLetters: reactive([]),
          isletterActive: ref(false),
          lobLetter: reactive({}),
          extraServices: reactive(
            {
              'certified': 'Certified',
              'certified_return_receipt': 'Certified Return Receipt',
              'registered': 'Registered'
            }
          ),
          mailTypes: reactive(
            {
              'usps_first_class': 'USPS First Class',
              'usps_standard': 'USPS Standard'
            }
          ),
          moment: moment,
          baseUrl: baseUrl
        }
      },
      mounted() {
        useLobSettingStore().fetchLobSetting();
      },
      data(){
      return {
        isLoading: true,
        columns: [
          {
            label: 'Thumbnail',
            field: 'thumbnail',
            width: '120px',
          },
          {
            label: 'Description',
            field: 'description',
            type: 'string',
          },
          {
            label: 'Recipient',
            field: 'to.name',
            type: 'string',
          },
          {
            label: 'Date Created',
            field: 'date_created',
            formatFn: this.formatDate,
            // type: 'date',
            // dateInputFormat: 'yyyy-MM-dd',
            // dateOutputFormat: 'MMM do yy',
          },
          {
            label: 'Action',
            field: 'action',
          }
        ],
        rows: [],
        totalRecords: 0,
        localizationStore: useLocalizationStore(),

      };
    },
    watch: {
      'lobSettingStore.lobSetting'(value) {
        if (value != null) {
          this.getLetters(this.lobSettingStore.lobSetting.lob_host + '/letters', 10)
        }
      }
    },
    methods: {
      getLetters(url, limit) {
        let $this = this;
        if (limit != null) {
          const queryParams = new URLSearchParams({
            'limit': limit,
            'include[]': 'total_count'
          });
          url = url + '?' + queryParams.toString();
        }
        
        axios.get(
          url,
          {
            auth: {
              username: $this.lobSettingStore.getUsername()
            }
          }
        ).then(function(response) {
          $this.lobLetters = response.data;
          $this.rows = $this.lobLetters.data;
          $this.totalRecords = $this.lobLetters.total_count;
          $this.isLoading = false;
        }).catch(function(error) {
          $this.rows = [];
          $this.totalRecords = 0;
          toastr.error(error.response.data.error.message, 'Error!');
        });
      },    
      onPageChange(params) {
        if (params.prevPage < params.currentPage) { // Next
          this.getLetters(this.lobLetters.next_url, null);
        }
        else { // Previous
          this.getLetters(this.lobLetters.previous_url, null);
        }
      },
      onPerPageChange(params) {
        this.getLetters(this.lobSettingStore.lobSetting.lob_host + '/letters', params.currentPerPage);
      },
      viewLetter(id) {
        let $this = this;
        axios.get(
          `${this.lobSettingStore.lobSetting.lob_host}/letters/${id}`,
          {
            auth: {
              username: this.lobSettingStore.getUsername()
            }
          }
        ).then(function(response) {
          $this.lobLetter = response.data;
          $this.isletterActive = true;
        }).catch(function(error) {
          toastr.error(error.response.data.error.message, 'Error!');
        });
      },
      deleteLetter(id) {
        let $this = this;
        Swal.fire({
          title: 'Are you sure you want to delete a letter?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1'
          },
          buttonsStyling: false
        }).then(function (result) {
          if (result.value) {
            axios.delete(
              `${$this.lobSettingStore.lobSetting.lob_host}/letters/${id}`,
              {
                auth: {
                  username: $this.lobSettingStore.getUsername()
                }
              }
            ).then(function(response) {
              if (response.data.deleted == true) {
                $this.getLetters($this.lobSettingStore.lobSetting.lob_host + '/letters', 10);
                toastr.success($this.localizationStore.translate("lob.letter.deleted.message"), 'Success!');
              }
              return;
            }).catch(function(error) {
              toastr.error(error.response.data.error.message, 'Error!');
            });
          }
        });
        
        
      },
      modeChange()
      {
        this.getLetters(this.lobSettingStore.lobSetting.lob_host + '/letters', 10);
      },
      goBack() 
      {
        this.isletterActive = false;  
      },
      formatDate(date)
      {
        return this.moment(date).format('llll');
      }
    }
  }
</script>